import { Info } from 'lucide-react';

export const DisclaimerNotice = ({ 
  variant = 'default',
  className = ''
}) => {
  const variants = {
    default: 'bg-[#F2EBE3] border-[#E5E5E5] text-[#374151]',
    subtle: 'bg-[#F5F5F0] border-transparent text-[#6B7280]',
    inline: 'bg-transparent border-transparent text-[#6B7280]',
  };

  if (variant === 'inline') {
    return (
      <p data-testid="disclaimer-notice" className={`text-xs italic font-accent ${className}`}>
        This content is for informational purposes only and is not medical advice. Always consult a healthcare professional.
      </p>
    );
  }

  return (
    <div 
      data-testid="disclaimer-notice"
      className={`p-4 border rounded-sm ${variants[variant]} ${className}`}
    >
      <div className="flex items-start gap-3">
        <Info className="w-4 h-4 flex-shrink-0 mt-0.5 opacity-60" />
        <p className="text-sm leading-relaxed">
          <span className="font-medium">Disclaimer:</span> This content is for informational purposes only and should not be considered medical advice. Always consult with a healthcare professional before starting any new skincare routine or supplement regimen.
        </p>
      </div>
    </div>
  );
};

export default DisclaimerNotice;
